import { LuSection } from 'react-icons/lu';
import { FiCompass, FiUsers } from 'react-icons/fi';

export const getIcon = ({ type }: { type: number }) => {
  switch (type) {
    case 1: {
      return <LuSection style={{ fontSize: '24px', color: '#98cb00' }} />;
    }
    case 2: {
      return <FiUsers style={{ fontSize: '24px', color: '#98cb00' }} />;
    }
    case 3: {
      return <FiCompass style={{ fontSize: '24px', color: '#98cb00' }} />;
    }
    default: {
      return;
    }
  }
};
